import { useState, useCallback, useEffect } from 'react';

export const useImageOrientation = (imageUrls = []) => {
  const [imageOrientations, setImageOrientations] = useState({});

  const checkImageOrientation = useCallback(
    (imageUrl) =>
      new Promise((resolve) => {
        if (imageOrientations[imageUrl] !== undefined) {
          resolve(imageOrientations[imageUrl]);
          return;
        }

        const img = new Image();
        img.onload = () => {
          const isHorizontal = img.naturalWidth > img.naturalHeight;
          setImageOrientations((prev) => ({
            ...prev,
            [imageUrl]: isHorizontal,
          }));
          resolve(isHorizontal);
        };
        img.onerror = () => {
          setImageOrientations((prev) => ({
            ...prev,
            [imageUrl]: false,
          }));
          resolve(false);
        };
        img.src = imageUrl;
      }),
    [imageOrientations],
  );

  // Auto-load orientations for provided URLs
  useEffect(() => {
    const loadOrientations = () => {
      imageUrls
        .filter((imageUrl) => imageUrl && !imageOrientations[imageUrl])
        .forEach((imageUrl) => {
          checkImageOrientation(imageUrl);
        });
    };

    if (imageUrls.length > 0) {
      loadOrientations();
    }
  }, [imageUrls, imageOrientations, checkImageOrientation]);

  return { imageOrientations, checkImageOrientation };
};

export default useImageOrientation;
